<template>
    <v-app>
        <v-container fluid>
            <div>
                <transition name="modal-fade">
                    <div class="modal-backdrop">
                        <section class="modal-body">
                            <div class="modal-content">
                                <v-card-title class="pa-3 pb-0">
                                    <p class="paragraph-font-size">Wyślij zgłoszenie do organu zewnętrznego</p>
                                </v-card-title>

                                <v-text-field v-model="externalSignal.name"
                                              :counter="250"
                                              label="Nazwa organu zewnętrznego"
                                              required></v-text-field>

                                <v-text-field v-model="externalSignal.emailTo"
                                              :rules="emailRules"
                                              :counter="100"
                                              label="e-mail adresata"
                                              required></v-text-field>

                                <v-text-field v-model="externalSignal.emailCc"
                                              :rules="emailRulesCc"
                                              :counter="100"
                                              label="e-mail DW"></v-text-field>

                                <v-textarea v-model="externalSignal.body"
                                            solo
                                            auto-grow
                                            label="Treść..."></v-textarea>

                                <v-checkbox v-model="externalSignal.withFiles" label="Udostępnij załączniki znajdujące się w zgłoszeniu"></v-checkbox>
                            </div>
                            <v-row align="center" justify="space-around" class="row-padding">
                                <v-btn color="default" @click="close()" class="btn-width-default">Anuluj</v-btn>
                                <v-btn color="primary" @click="sendExternalSignal()" class="btn-width-save" :disabled="chechEmailLength(externalSignal.emailTo) == false || validateEmail(externalSignal.emailTo) == false">Wyślij</v-btn>
                            </v-row>
                        </section>
                    </div>
                </transition>
            </div>
        </v-container>
    </v-app>
</template>

<script>

    export default {
        name: 'SendExternalModal',

        props: {
            externalToSend: {
                type: Object,
                required: true,
            },
        },
        data() {
            return {
                externalSignal: { ...this.externalToSend },
                emailRules: [
                    v => !!v || 'E-mail jest wymagany',
                    v => this.validateEmail(v) || 'Niepoprawny E-mail',
                ],
                emailRulesCc: [
                    v => !v || this.validateEmail(v) || 'Niepoprawny E-mail',
                ],
            };
        },
        methods: {
            validateEmail(email) {
                // eslint-disable-next-line
                const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },
            chechEmailLength(email) {
                if (email == undefined)
                    return false;
                
                if (email.length == 0)
                    return false;

                return true;
            },
            close() {
                this.$emit('close');
            },
            sendExternalSignal() {
                this.$emit("sendExternalSignal", { ...this.externalSignal });
            },
        },
        watch: {
            externalToSend: {
                immediate: true,
                handler(external) {
                    this.externalSignal = { ...external };
                },
            },
        },
    };
</script>

<style scoped>
    .row-padding {
        padding-bottom: 15px;
    }

    .btn-width-default {
        max-width: 100px;
    }

    .btn-width-save {
        max-width: 300px;
    }

    .paragraph-font-size {
        font-size: 20px;
    }

    .modal-backdrop {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: rgba(0, 0, 0, 0.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 9999;
        border: none;
        box-shadow: none;
    }

    .modal-body {
        background-color: white;
        max-width: 750px; /* zwiększona szerokość */
        min-width: 600px;
        max-height: 80vh; /* ograniczona wysokość */
        padding: 20px;
        overflow-y: auto; /* Dodane przewijanie */
        border: none;
    }

    .modal-content {
        border: none !important;
    }

    .modal-fade-enter,
    .modal-fade-leave-to {
        opacity: 0;
    }

    .modal-fade-enter-active,
    .modal-fade-leave-active {
        transition: opacity .5s ease;
    }
</style>
